export const SelectChitTermStyle = theme => ({
    SelectChitTermContainer: {
        padding: '0px',
        minWidth: '20px',
        maxWidth: '140px'
    }
})